var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "success",
    fill: "#0D9548",
    d: "M103.869-824.131a31.2,31.2,0,0,1-12.494-2.519,32.291,32.291,0,0,1-10.153-6.835,32.292,32.292,0,0,1-6.835-10.153,31.19,31.19,0,0,1-2.518-12.493,31.2,31.2,0,0,1,2.518-12.494,32.287,32.287,0,0,1,6.835-10.152,32.275,32.275,0,0,1,10.153-6.835,31.179,31.179,0,0,1,12.494-2.519,31.5,31.5,0,0,1,9.644,1.452,32.638,32.638,0,0,1,8.427,4.08l-5.2,5.282a26.767,26.767,0,0,0-6.076-2.706,23.289,23.289,0,0,0-6.791-.974,23.987,23.987,0,0,0-17.6,7.256A23.96,23.96,0,0,0,79-856.131a23.96,23.96,0,0,0,7.265,17.608,23.983,23.983,0,0,0,17.6,7.256,23.983,23.983,0,0,0,17.6-7.256,23.96,23.96,0,0,0,7.265-17.608,24.307,24.307,0,0,0-.138-2.585,21.98,21.98,0,0,0-.414-2.514l5.828-5.827a33.46,33.46,0,0,1,1.38,5.3,32.418,32.418,0,0,1,.48,5.621,31.212,31.212,0,0,1-2.518,12.5,32.293,32.293,0,0,1-6.835,10.153,32.29,32.29,0,0,1-10.153,6.835A31.2,31.2,0,0,1,103.869-824.131Zm-4.447-17.2-13.61-13.61,4.9-4.916,8.713,8.714,31.531-31.61,4.916,4.916Z",
    transform: "translate(-71.869 888.131)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bbf2cf304686ade5ab328685713d576c.svg";
export { ForwardRef as ReactComponent };